import { render, staticRenderFns } from "./EntityEmailView.vue?vue&type=template&id=94a696f8&scoped=true"
import script from "./EntityEmailView.vue?vue&type=script&lang=js"
export * from "./EntityEmailView.vue?vue&type=script&lang=js"
import style0 from "./EntityEmailView.vue?vue&type=style&index=0&id=94a696f8&prod&scoped=true&lang=css"
import style1 from "./EntityEmailView.vue?vue&type=style&index=1&id=94a696f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a696f8",
  null
  
)

export default component.exports